export default __webpack_public_path__ + "static/media/dupixent-logo-updated.6fd60727.png";